import * as React from 'react';
import Cookies, { CookieSetOptions } from 'universal-cookie';
import { useCookiesContext } from './CookiesContext';

export default function useCookies<T extends string>(
    _names: T[],
    defaultOptions?: Partial<CookieSetOptions>
): [
    Cookies | undefined,
    (key: T, value: string, options?: Partial<CookieSetOptions>) => Promise<void>,
    (key: T, options?: Partial<CookieSetOptions>) => Promise<void>
] {
    const cookies = useCookiesContext();
    const refCookies = React.useRef(cookies);

    const setCookies = React.useCallback(
        async (key: T, value: string, options?: Partial<CookieSetOptions>) => {
            if (refCookies.current) {
                refCookies.current.set(key, value, { ...defaultOptions, ...options });
            }
        },
        [defaultOptions]
    );

    const removeCookies = React.useCallback(
        async (key: T, options?: Partial<CookieSetOptions>) => {
            if (refCookies.current) {
                refCookies.current.remove(key, { ...defaultOptions, maxAge: -1, ...options });
            }
        },
        [defaultOptions]
    );

    return [refCookies.current, setCookies, removeCookies];
}
